import {
  AuctionBiddingEngine,
  AuctionBiddingStatus,
  AuctionType,
  EAuctionBiddingEngine,
  EAuctionBiddingStatus,
  EAuctionStatus,
  EAuctionType,
  SaleStatus,
} from '@bonhams1793/bonhams-typescript'

export const canAuctionBeRegisteredFor = ({
  auctionType,
  auctionStatus,
  rowId,
  biddingStatus,
  biddingEngine,
}: {
  auctionType: EAuctionType
  auctionStatus: EAuctionStatus
  rowId?: string
  biddingStatus: EAuctionBiddingStatus
  biddingEngine: EAuctionBiddingEngine | null
}) => {
  const checkAuctionStatus =
    auctionStatus === SaleStatus.ready &&
    ![AuctionType.private, AuctionType.exhibition].includes(auctionType) &&
    biddingStatus !== AuctionBiddingStatus.ended

  if (biddingEngine === AuctionBiddingEngine.AM) {
    return checkAuctionStatus && !!rowId
  } else if (biddingEngine === AuctionBiddingEngine.BBE) {
    return checkAuctionStatus
  }

  return false
}
